export var InfoBlockStatus;
(function (InfoBlockStatus) {
    InfoBlockStatus["SUCCESS"] = "success";
    InfoBlockStatus["WARNING"] = "warning";
    InfoBlockStatus["ERROR"] = "error";
    /** @deprecated use ERROR instead */
    InfoBlockStatus["DANGER"] = "danger";
})(InfoBlockStatus || (InfoBlockStatus = {}));
//# sourceMappingURL=InfoBlockEnum.js.map